import React from 'react';

function LoadingSkeleton() {
  return (
    <div className="ahri-dash">
      <div className="ahri-dash-skeleton mb-4" style={{ height: 200, borderRadius: '1.25rem' }} />
      <div className="ahri-dash-section mb-4">
        <div className="ahri-dash-skeleton m-3" style={{ height: 32, width: '45%' }} />
        {[1, 2, 3, 4, 5, 6].map((key) => (
          <div key={key} className="d-flex gap-3 px-3 pb-3">
            <div className="ahri-dash-skeleton rounded-circle flex-shrink-0" style={{ height: 44, width: 44 }} />
            <div className="flex-grow-1">
              <div className="ahri-dash-skeleton mb-2" style={{ height: 20, width: '55%' }} />
              <div className="ahri-dash-skeleton mb-2" style={{ height: 14, width: '35%' }} />
              <div className="ahri-dash-skeleton" style={{ height: 56, width: '100%', maxWidth: 280 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LoadingSkeleton;
